import { Box, LinkBox, LinkOverlay, Stack, Text, VStack, Flex, Link } from '@chakra-ui/react'

import { buildSearchUrl } from '@!/Util'
import { CoverImage, PriceLabel } from '@!/Store/Common/components'
import { PurchasedLabel } from './PurchasedLabel'
import { SampleButton } from '@!/Store/Common/components/BookList/Button'
import { AuthorList } from '@!/components/List'

export const ListItem = (props) => {
  const { title, imageUrl, authorName, publisherName, price, regularPrice, sampleBookId, contentId, adultFlag, sampleFilePath, linkUrl, isPurchased } = props

  return (
    <LinkBox py={3}>
      <Stack direction="row" spacing={0}>
        <Box mr="0.5rem">
          <CoverImage src={imageUrl} alt={title} width="90px" />
        </Box>
        <VStack spacing={0} w="100%">
          <Box w="100%">
            <Text fontWeight="bold">
              <LinkOverlay href={linkUrl}>{title}</LinkOverlay>
            </Text>
            <Box my={2}>
              {authorName && (
                <Text fontSize="2xs">
                  著者：
                  <AuthorList authors={authorName} />
                </Text>
              )}
              {publisherName && (
                <Text fontSize="2xs">
                  出版社：
                  <Link textDecoration="none" href={buildSearchUrl('publisher', publisherName)}>
                    {publisherName}
                  </Link>
                </Text>
              )}
            </Box>
            {isPurchased ? <PurchasedLabel /> : <PriceLabel price={price} regularPrice={regularPrice} />}
          </Box>
          <Flex w="100%" justifyContent="flex-end">
            {sampleBookId && sampleFilePath && price !== 0 && !isPurchased && (
              <Box w="124px" h="37px">
                <SampleButton
                  contentId={contentId}
                  sampleBookId={sampleBookId}
                  sampleFilePath={sampleFilePath}
                  adultFlag={adultFlag}
                  price={price}
                  isPurchased={isPurchased}
                />
              </Box>
            )}
          </Flex>
        </VStack>
      </Stack>
    </LinkBox>
  )
}
